(function () {
  'use strict';

  angular
      .module('tfc.retailer.ProductDetail')
      .factory('ProductDetail', ProductDetail);

  // @ngInject
  function ProductDetail($q, Api, BrandReports, ApiFallback, ApiStatusCodes, BRAND_URL, STYLE_URL) {

    var productDetailFallBack = ApiFallback.createFallback(isStatusCodeHandled, handleNotFoundError);

    function handleNotFoundError() {
      return $q.resolve();
    }

    function isStatusCodeHandled(statusCode) {
      return _.eq(statusCode, ApiStatusCodes.NotFound);
    }

    return {
      selectedBrandKey : selectedBrandKey,
      getProductStyleSummary: productStyleSummary,
      getProductStyleSizeAdvice: productStyleSizeAdvice,
      getPurchaseAttributeStyle: purchaseAttributeStyle,
      getPurchaseAffinityTopBrands: purchaseAffinityTopBrands,
      getPurchaseAffinityCategoryTopBrands : purchaseAffinityCategoryTopBrands,
      getFitConsistencySizeAdvice : fitConsistencySizeAdvice,
      getConsumerStylesHeight: consumerStylesHeight,
      getConsumerStylesWeight: consumerStylesWeight,
      getConsumerStylesAgeRange: consumerStylesAgeRange
    };

    function selectedBrandKey(brandKey) {
      return BrandReports.selectedBrandKey(brandKey);
    }

    function productStyleSummary(brandKey, styleId, region, transaction){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/summary', {
        params: {region:region, transaction: transaction},
        specificallyHandled: true
      }, productDetailFallBack).then(_.property('data'));
    }

    function productStyleSizeAdvice(brandKey, styleId, region, transaction){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/sizeAdvice', {
        params: {region:region, transaction: transaction},
        specificallyHandled: true
      }, productDetailFallBack).then(_.property('data'));
    }

    function purchaseAttributeStyle(brandKey, styleId, region, transaction, category, department){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/attributes', {
        params: {department: department, category: category, transaction: transaction, region: region},
        specificallyHandled: true
      }, productDetailFallBack).then(_.property('data'));
  }

    function purchaseAffinityTopBrands(brandKey, styleId, region, transaction){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/affinity/brands/top', {
        params: {region:region, transaction: transaction}
      }).then(_.property('data'));
    }

    function purchaseAffinityCategoryTopBrands(brandKey, styleId, region, transaction, category, department){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/affinity/brands/top', {
        params: {affinityDepartment: department, affinityCategory: category, region:region, transaction: transaction}
      }).then(_.property('data'));
    }

    function fitConsistencySizeAdvice(brandKey, region, transaction, category, department){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/styles/sizeAdvice', {
        params: {department: department, category: category, transaction: transaction, region: region}
      }).then(_.property('data'));
    }

    function consumerStylesHeight(brandKey, styleId, region, transaction) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/consumer/height',
          {
            params: {region: region, transaction: transaction}
          }
      ).then(_.property('data'));
    }

    function consumerStylesWeight(brandKey, styleId, region, transaction) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/consumer/weight',
          {
            params: {region: region, transaction: transaction}
          }
      ).then(_.property('data'));
    }

    function consumerStylesAgeRange(brandKey, styleId, region, transaction) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + Api.withEncodedPath(STYLE_URL, styleId) + '/consumer/ageRange',
          {
            params: {region: region, transaction: transaction}
          }).then(_.property('data'));
    }

  }

})();
